module.exports = __webpack_public_path__ + "img/car2ip_02.5e27658d.png";